(function () {
    'use strict';

    angular
        .module('app.quotes', ['app.core']);

})();
